import React, { useState } from "react";
import View from "@mui/material/Box";
import Text from "@mui/material/Typography";
import RequiredQuestion from "components/RequiredQuestion";
import LoadingBtn from "components/LoadingBtn/LoadingBtn";
import { handleSaveRequiredValues } from "@utils/functions";

export const ProfileCharacterDeath = ({ state, handleEditProfile, pushCounter }) => {
    const hasState = () => {
        if (!state?.characterDeath) {
            return "";
        }

        return String(state?.characterDeath);
    };

    const [textValue, setTextValue] = useState(hasState);
    const [isLoading, setIsLoading] = useState(false);

    const deathOptions = ["No.", "Depends on the game.", "I embrace character death."];

    return (
        <View className="form-container">
            <Text as="h2">
                Are you ok with characters dying?<small>*</small>
            </Text>

            {
                // loop through the array and build button options
                Object.values(deathOptions).map((item, index) => (
                    <View className="button-container" key={index}>
                        <LoadingBtn
                            label={item}
                            variant="outlined"
                            loading={textValue === item && isLoading}
                            handleOnClick={() =>
                                handleSaveRequiredValues({
                                    key: "characterDeath",
                                    item,
                                    setTextValue,
                                    setIsLoading,
                                    handleEditProfile,
                                })
                            }
                            className={textValue === item ? "selected-but" : "safety-but"}
                        />
                    </View>
                ))
            }
        </View>
    );
};
export default ProfileCharacterDeath;
